module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n    viewBox=\"0 0 36 36\">\r\n  <path d=\"M18,6A12,12,0,1,0,30,18,12,12,0,0,0,18,6Zm0,22A10,10,0,1,1,28,18,10,10,0,0,1,18,28Z\"></path>\r\n  <path d=\"M16.34,23.74l-5-5a1,1,0,0,1,1.41-1.41l3.59,3.59,6.78-6.78a1,1,0,0,1,1.41,1.41Z\"></path>\r\n</svg>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-alert/icons/success.html
// module id = 290
// module chunks = 0